export default {
  ProtocolManagementTitle: 'Protocol Management',
  buttonNewProtocol: 'New Protocol',
  protocolName: 'Protocol Name',
  transportType: 'Transport Type',
  description: 'Description',
  protocolCode: 'Protocol Code',
  confirmDeleteProtocol: 'Confirm delete protocol?',
  deleteSuccess: 'Protocol deleted successfully',
  buttonEditProtocol: 'Edit Protocol',
  saveSuccess: 'Protocol saved successfully',
}
